import React from 'react';

const DeleteAccount = () => {
  return (
    <div style={{
      maxWidth: '800px',
      margin: 'auto',
      backgroundColor: '#fff',
      padding: '30px',
      borderRadius: '8px',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)',
      fontFamily: 'Cairo, sans-serif',
      direction: 'rtl'
    }}>
      <h1 style={{ color: '#d63031', textAlign: 'center' }}>طلب حذف الحساب</h1>
      <p>نحن نحترم خصوصيتك ونمنحك التحكم الكامل في بياناتك.</p>
      <p>إذا كنت ترغب في حذف حسابك وجميع بياناتك المرتبطة في تطبيق <strong>AT Delivery</strong>، يُرجى إرسال طلب عبر البريد الإلكتروني إلى العنوان التالي:</p>
      <div style={{
        backgroundColor: '#f1f2f6',
        padding: '10px',
        borderRadius: '5px',
        fontWeight: 'bold',
        direction: 'ltr',
        margin: '10px 0'
      }}>
        info@atdelivery.net
      </div>
      <p>يرجى تضمين المعلومات التالية في رسالتك:</p>
      <ul>
        <li>الاسم الكامل</li>
        <li>رقم الهاتف المرتبط بالحساب</li>
        <li>البريد الإلكتروني المستخدم في التطبيق</li>
      </ul>
      <p>بعد استلام طلبك، سنقوم بحذف الحساب وجميع البيانات المرتبطة خلال <strong>7 أيام عمل</strong>.</p>
      <p>إذا كان لديك أي استفسارات إضافية، لا تتردد في التواصل معنا عبر نفس البريد الإلكتروني.</p>
      <p style={{ textAlign: 'center', color: '#999', fontSize: '14px', marginTop: '40px' }}>
        &copy; 2025 AT Delivery. جميع الحقوق محفوظة.
      </p>
    </div>
  );
};

export default DeleteAccount;
